import { Membership } from "../../../business-objects/membership/membership.model";
import { isInArray } from "../../../../core/util/is-in-array";
import { isArray } from "util";
import { User } from "../../../business-objects/user/user.model";
import { AclCategoryModalItemModel } from "./acl-category-modal-item.model";
import { FormGroup } from "@angular/forms";
import { SelectOption } from "../../../../core/interfaces/select-option";
import { AccessGroup } from "../../../business-objects/access-group/access-group.model";

export interface IAclCategoryModalModelArgs {
    accessGroups: Array<AccessGroup>;
    filterFormGroup: FormGroup;
    items: Array<AclCategoryModalItemModel>;
}

export interface IAclCategoryModalModelGetInstanceArgs {
    accessGroups: Array<AccessGroup>;
    activeMembership: Membership;
    category: string;
    categoryId: string;
    filterFormGroup: FormGroup;
    memberships: Array<Membership>;
    users: Array<User>;
}

export class AclCategoryModalModel {
    protected _accessGroups: Array<AccessGroup>;
    protected _filterFormGroup: FormGroup;
    protected _items: Array<AclCategoryModalItemModel>;

    static getInstance(args: IAclCategoryModalModelGetInstanceArgs): AclCategoryModalModel {

        if (!isArray(new Membership()[args.category])) {
            throw new Error(`${args.category} is not a valid category`);
        }

        return new AclCategoryModalModel({
            accessGroups: args.accessGroups,
            filterFormGroup: args.filterFormGroup,
            items: args.memberships.map(membership => {
                return new AclCategoryModalItemModel({
                    membership,
                    activeMembership: args.activeMembership,
                    category: args.category,
                    categoryId: args.categoryId,
                    enabled: membership.id === args.activeMembership.id || isInArray(args.categoryId, membership[args.category]),
                    user: args.users.find(user => user.id === membership.user)
                });
            })
        });
    }

    constructor(args: IAclCategoryModalModelArgs) {
        Object.keys(args).forEach(key => {
            this[`_${key}`] = args[key];
        });
    }

    get accessGroupOptions(): Array<SelectOption> {
        return (this._accessGroups || [])
            .sort((a, b) => a.title.localeCompare(b.title))
            .map(accessGroup => new SelectOption(accessGroup.id, accessGroup.title));
    }

    get filterFormGroup(): FormGroup {
        return this._filterFormGroup;
    }

    get items(): Array<AclCategoryModalItemModel> {
        return (this._items || [])
            .filter(item => this.filter(item))
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    protected get searchTerm(): string {
        return this._filterFormGroup.get("searchTerm").value;
    }

    protected get filterAccessGroup(): string {
        return this._filterFormGroup.get("accessGroup").value;
    }

    get submitData(): Array<Membership> {
        return this.items
            .map(item => item.submitData);
    }

    protected filter(item: AclCategoryModalItemModel): boolean {

        if (this.searchTerm) {
            if (item.label.toLowerCase().indexOf(this.searchTerm.toLowerCase()) === -1) {
                return false;
            }
        }

        if (this.filterAccessGroup) {
            if (!isInArray(this.filterAccessGroup, item.accessGroupIds)) {
                return false;
            }
        }

        return true;
    }

    grant(itemModel: AclCategoryModalItemModel): AclCategoryModalModel {

        const items = [...this.items.filter(item => item !== itemModel), itemModel.grant()];

        return new AclCategoryModalModel({
            accessGroups: this._accessGroups,
            filterFormGroup: this._filterFormGroup,
            items
        });
    }

    grantAll(): AclCategoryModalModel {

        const itemsToUpdate = this.items;

        const items = [
            ...this._items.filter(item => !isInArray(item, itemsToUpdate)),
            ...itemsToUpdate.map(item => item.grant())
        ];

        return new AclCategoryModalModel({
            accessGroups: this._accessGroups,
            filterFormGroup: this._filterFormGroup,
            items
        });
    }

    revoke(itemModel: AclCategoryModalItemModel): AclCategoryModalModel {

        const items = [...this.items.filter(item => item !== itemModel), itemModel.revoke()];

        return new AclCategoryModalModel({
            accessGroups: this._accessGroups,
            filterFormGroup: this._filterFormGroup,
            items
        });
    }

    revokeAll(): AclCategoryModalModel {

        const itemsToUpdate = this.items;

        const items = [
            ...this._items.filter(item => !isInArray(item, itemsToUpdate)),
            ...itemsToUpdate.map(item => item.revoke())
        ];

        return new AclCategoryModalModel({
            accessGroups: this._accessGroups,
            filterFormGroup: this._filterFormGroup,
            items
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/form/acl-category-modal.model.ts